<template>
	<v-storyblok-rich-text :document="document" :no-prose="noProse" />
</template>

<script setup lang="ts">
import type {SbRichTextDoc as ISbRichtext} from "@storyblok/js";

defineProps<{
	document?: ISbRichtext | string;
	noProse?: boolean;
}>();
</script>
